import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { BannerKey } from '@/types/Banners/IBanner';

/**
 * The subscription notices of the billing pages (`billingNotices` page prop).
 * Unlike the top-of-page banners they are not ranked, product-filtered or
 * dismissible, so a billing page always explains its own product's state.
 */
export const useBillingNotices = () => {
    const billingNotices = computed<BannerKey[]>(
        () =>
            usePage<{ billingNotices?: BannerKey[] }>().props.billingNotices ??
            []
    );

    const hasBillingNotice = (key: BannerKey) =>
        computed(() => billingNotices.value.includes(key));

    return { billingNotices, hasBillingNotice };
};

export default useBillingNotices;
